// extracted by mini-css-extract-plugin
export default {"invalidDataError":"ProductSTyle_invalidDataError__0HBhR"};